export class Client {
  _id: string;
  fname: string;
  lname: string;
  email: string;
  phone: string;
  uname: string;
  Linkedin: string;
}
